import { IDexieAxMachineModel } from '../dexie/DexieAxMachineModel';

export interface IAxMachineModel {
    /**
     * The machine type id string.
     * On api side this is called just id, bud we need id for dexi-db
     */
    typeId: string;
    /**
     * The machine id corresponding to the  machine section identifier
     * from the machines configuration
     */
    machineId: string;
    /**
     * Model of the machine
     */
    model: string;
    /**
     * machineTypeId
     */
    machineTypeId: string;
    /**
     * machineType
     */
    machineType: string;

    /**
     * An optinal list of commission numbers for this model for a given customer
     */
    commissonNumbers?: string[];
    /**
     * An optinal list of serial numbers for this model for a given customer
     */
    serialNumbers?: string[];
}

export class AxMachineModel implements IAxMachineModel {
    public typeId: string = '';
    public machineId: string;
    public model: string;
    public machineTypeId: string;
    public machineType: string;
    public commissonNumbers?: string[];
    public serialNumbers?: string[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxMachineModel);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieAxMachineModel);
    constructor(obj?: any) {
        if (obj && obj.id) {
            this.typeId = obj && obj.id || '';
        } else if (obj && obj.typeId) {
            this.typeId = obj && obj.typeId || '';
        }
        this.machineId = obj && obj.machineId || '';
        this.model = obj && obj.model || '';
        this.machineTypeId = obj && obj.machineTypeId || '';
        this.machineType = obj && obj.machineType || '';

        if (obj && obj.commissonNumbers) {
            this.commissonNumbers = [];
            obj.commissonNumbers.forEach((cn: string) => {
                this.commissonNumbers!.push(cn);
            });
        }
        if (obj && obj.serialNumbers) {
            this.serialNumbers = [];
            obj.serialNumbers.forEach((cn: string) => {
                this.serialNumbers!.push(cn);
            });
        }
    }
}
